import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";

export class OutletProvider {
  static async getSelectedServices() {
    return await $axios.get($api("selected_services"));
  }
  static async getAllServices() {
    return await $axios.get($api("get_all_services"));
  }

  static async getServiceDetails(params: { service_id: string | undefined }) {
    return await $axios.get($api("get_service", params));
  }
  static async getCampaign() {
    return await $axios.get($api("get_campaign"));
  }
  static async getShowCampaing(id: string | undefined) {
    return await $axios.get($api("show_campaign", { id }));
  }
  static async getMostSeller() {
    return await $axios.get($api("get_most_seller"));
  }
  static async getPhonePrefix() {
    return await $axios.get($api("get_phone_prefix"));
  }
  static async postShowProducts(params: { id: string | undefined }) {
    return await $axios.get($api("show_product", params));
  }
  static async getAllBlogsData() {
    return await $axios.get($api("get_all_blogs"));
  }
  static async getAllPartners() {
    // return await $axios.get($api("get_all_partners")); // Disabled: not needed
    return { data: { partners: [] } };
  }
  static async postAddToWishlist(payload: { product_id: number }) {
    return await $axios.post($api("favorites", payload));
  }

  static async getFavorites() {
    return await $axios.get($api("favorites"));
  }

  static async removeFromFavorites(id: number) {
    return await $axios.delete($api("remove_favorites", { id }));
  }
  static async getOfferWeek() {
    // return await $axios.get($api("get_offer_week")); // Disabled: /weekly-picks returns 404
    return { data: [] };
  }
  static async clearFavorites() {
    return await $axios.delete($api("favorites"));
  }
  static async getPartnors() {
    return await $axios.get($api("get_officialServices"));
  }
   static async getOutletHero() {
    return await $axios.get($api("get_outlet_heroes"));
  }
}
